ActionList = require 'models/collections/action-list'
ActionListView = require 'views/action/action-list-view'
Payloads = require 'network/payloads'
ViewWithActions = require 'views/internal/view-with-actions'
View = require 'view'
mixin = require 'lib/mixin'
simpleTest = require 'lib/experiments/simple-test'
templates = require 'views/internal/templates'
track = require 'debug/track'
t = require('views/internal/teacup-with-helpers')('board_menu_activity')

subscribedTemplate = t.renderable ({ subscribed }) ->
  t.div '.board-menu-activity-subscription-state', ->
    if subscribed
      t.icon 'subscribe'
    t.format if subscribed then 'subscribed' else 'not-subscribed'

  if subscribed
    t.div '.board-menu-activity-subscription-toggle.quiet.js-unsubscribe', ->
      t.format 'unsubscribe'
  else
    t.div '.board-menu-activity-subscription-toggle.quiet.js-subscribe', ->
      t.format 'subscribe'

class SubscribedView extends View
  className: 'board-menu-activity-subscription'

  initialize: ->
    @listenTo @model, 'change:subscribed', @render

  events:
    'click .js-subscribe': (e) ->
      @model.subscribe(true)
    'click .js-unsubscribe': (e) ->
      @model.subscribe(false)

  render: ->
    @$el.html(subscribedTemplate({
      subscribed: @model.get('subscribed')
    }))
    @

mixin ViewWithActions, class BoardMenuActivityView extends View
  viewTitleKey: 'activity'
  viewIcon: 'activity'
  isTopLevelTab: true

  initialize: ->
    @mode = 'all'

    { @fullHistory } = @options
    @fullHistory ?= false

    @actionListView = @collectionSubview ActionListView, new ActionList(@getActions(), { @modelCache }),
      renderOpts:
        compact: !@fullHistory
        key: 'boardmenuactivity'
        context: @model

    @makeDebouncedMethods 'renderMoreActionsLink'

    @listenTo @modelCache, "add:Action:#{@model.id}", =>
      @actionListView.collection.reset(@getActions())
      @renderMoreActionsLinkDebounced()

    @loadMoreActions()

    return

  className: 'board-menu-content-frame'

  events:
    'click .js-show-all': 'showAll'
    'click .js-show-comments': 'showComments'
    'click .js-more-actions': 'loadMoreActions'

  render: ->

    @$el.html(
      templates.fill(
        'board_menu_activity',
        @model.toJSON()
      )
    )

    @actionListView.setElement @$('.js-list-activity')[0]
    @renderActions()
    @renderMode()

    @

  renderActions: ->
    @actionListView.render()
    @renderMoreActionsLink()

  renderMoreActionsLink: ->
    @$('.js-more-actions').toggle(@hasMoreActions())
    @

  renderMode: ->
    @$('.js-control-option').removeClass('is-active')

    if @mode == 'all'
      @$('.js-list-activity').removeClass('is-only-comments')
      @$('.js-show-all').addClass('is-active')
    else
      @$('.js-list-activity').addClass('is-only-comments')
      @$('.js-show-comments').addClass('is-active')

    @

  showAll: (e) ->
    @mode = 'all'
    @renderMode()
    track("Board Menu", "Activity", "Show All")
    return

  showComments: (e) ->
    @mode = 'comments'
    @renderMode()
    track("Board Menu", "Activity", "Show Comments Only")
    return

  setExtraTarget: ($el) ->
    @$elExtra = $el
    @renderExtra()

  renderExtra: ->
    if !@$elExtra
      return

    subscribedView = @subview(SubscribedView, @model)
    @$elExtra.html(subscribedView.render().el)

module.exports = BoardMenuActivityView



// WEBPACK FOOTER //
// ./app/scripts/views/board-menu/board-menu-activity-view.coffee